import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
// @ts-ignore
import cellEditFactory from "react-bootstrap-table2-editor";
import History from "../../utilities/History";

import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import {
  MODULE_PRODUCT,
  EDIT,
  CREATE,
  PRODUCT_INDEX_URL,
  CHANGE_EVENT,
  NOTIFICATION_TIMEOUT,
  NAME_VALIDATION_ERROR,
} from "../../utilities/Constants";
import { IProductFormData } from "../../models/product/ProductFormData";
import { ABB_EDIT, ABB_PLUS } from "../../utilities/IconConstants";
import SubmitHeader from "../shared/SubmitHeader";
import IFormComponent from "../../models/shared/FormComponent";
import {
  Input,
  Dropdown,
  DropdownOption,
  Dialog,
} from "@abb/abb-common-ux-react";
import gradeActions from "../../flux/actions/GradeActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import gradeListStore from "../../flux/stores/grade/ListStore";
import gradeByIdStore from "../../flux/stores/grade/ByIdStore";
import TableComponent from "../shared/TableComponent";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import tableFormatter from "../shared/TableFormatter";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import {
  IPropertySpecification,
  PropertySpecification,
} from "../../models/shared/PropertySpecification";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import propertySelectedIdStore from "../../flux/stores/property/BySelectedIdStore";
import productActions from "../../flux/actions/ProductActions";
import productFormStore from "../../flux/stores/product/FormStore";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import { GradeBasicData } from "../../models/grade/GradeBasicData";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import { IMeasuredPropertyData } from "../../models/shared/IMeasuredPropertyData";
import { IKeyedInPropertyData } from "../../models/shared/IKeyedInPropertyData";
import AbbTableComponent from "../shared/AbbTableComponent";
import { ICalculatedPropertyData } from "../../models/shared/ICalculatedPropertyData";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import i18next from "i18next";
import IdGenerator from "../../utilities/GenerateId";
import productListStore from "../../flux/stores/product/ListStore";
import { IProductViewData } from "../../models/product/ProductViewData";

type PropsType = RouteComponentProps & {};

interface IFormState {
  productFormData: IProductFormData;
  gradeDropdownList: any[];
  instrumentDropdownList: any[];
  modalWarningGradeChange: boolean;
  oldData: IProductFormData;
  formLoading: boolean;
  nameError: boolean;
  customCodeError: boolean;
}

class Form
  extends React.Component<PropsType, IFormState>
  implements IFormComponent
{
  private _mount: boolean = false;
  private _isReload: boolean;
  private _messages: string[];
  private _id: string;
  private _gradeDropdownList: IGradeViewData[] = [];
  private _selectedGrade: IGradeViewData;
  private _tempGrade: any[] = [];
  private _columns: IColumnHeaderData[];
  private _fetchedInstruments: IInstrumentViewData[] = [];
  private _fetchedProperties: IPropertyViewData[] = [];
  private _listData: any[];

  constructor(props: PropsType) {
    super(props);

    const pushStateData = this.props.location.state as IProductFormData;

    this.state = {
      productFormData: pushStateData,
      gradeDropdownList: [],
      instrumentDropdownList: [],
      modalWarningGradeChange: false,
      oldData: { ...pushStateData },
      formLoading: false,
      nameError: false,
      customCodeError: false,
    };
  }

  componentDidMount() {
    this._mount = true;
    this.validate();
    navigationHeaderActions
      .updateHeader({
        name: MODULE_PRODUCT,
        action: this.state.productFormData.isEditMode ? EDIT : CREATE,
        icon: this.state.productFormData.isEditMode ? ABB_EDIT : ABB_PLUS,
        goBackUrl: PRODUCT_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    gradeByIdStore.on(CHANGE_EVENT, (state) => {
      this._selectedGrade = state.gradeData;
    });

    gradeListStore.on(CHANGE_EVENT, (state) => {
      this._gradeDropdownList = state.gradeDataList.result;
    });

    gradeActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        const gradeDropdownList: any[] = [];
        this._gradeDropdownList.forEach((element: IGradeViewData) => {
          gradeDropdownList.push({
            label: element.name,
            value: element.id,
          });
        });

        this.setState(
          {
            gradeDropdownList,
          },
          () => {
            this.setState({
              productFormData: {
                ...this.state.productFormData,
                selectedGrade: this.state.productFormData.selectedGrade,
              },
            });
          }
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });

    propertySelectedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedProperties = state.data;
    });

    productFormStore.on(CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._id = state.productId;
        this._messages = state.messages;
      }
    });

    // if(!this.state.productFormData.isEditMode){
    //   productListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
    //     if (this._mount) {
    //       this._listData = state.productDataList.result as IProductViewData[];
    //       const code = this._listData[0].code;
    //       const id = IdGenerator.incrementId(code);
    //       const idString = id.toString();
  
    //       this.setState({
    //         productFormData: {
    //           ...this.state.productFormData,
    //           code: idString
    //         }
    //       });
    //     }
    //   });

    //   productActions
    //   .getAll(
    //     false,
    //     1,
    //     CONSTANTS.PAGE_SIZE,
    //     CONSTANTS.SORT_CREATEDON,
    //     CONSTANTS.SORT_ORDER,
    //     ""
    //   )
    //   .then();
    // }
  }
  componentDidUpdate() {
    if (
      JSON.stringify(this.state.oldData) !==
      JSON.stringify(this.state.productFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: MODULE_PRODUCT,
          action: this.state.productFormData.isEditMode ? EDIT : CREATE,
          icon: this.state.productFormData.isEditMode ? ABB_EDIT : ABB_PLUS,
          goBackUrl: PRODUCT_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  componentWillUnmount() {
    this._mount = false;
  }

  validate(): void {
    if (
      !this.state.nameError &&
      !this.state.customCodeError &&
      this.state.productFormData.grade.id !== "" &&
      this.state.productFormData.properties.length > 0
    ) {
      submitHeaderActions
        .update({
          moduleName: MODULE_PRODUCT,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: MODULE_PRODUCT,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  onCreateClick = () => {
    const tempName = this.state.productFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        productFormData: {
          ...prevState.productFormData,
          name: tempName,
        },
      }),
      () => {
        productActions
          .post(this.state.productFormData)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages).then();
                setTimeout(() => {
                  History.push(PRODUCT_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  onSaveClick = () => {
    const tempName = this.state.productFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        productFormData: {
          ...prevState.productFormData,
          name: tempName,
        },
      }),
      () => {
        productActions
          .put(this.state.productFormData)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  History.push(PRODUCT_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          nameError: false,
          productFormData: {
            ...this.state.productFormData,
            name: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          productFormData: {
            ...this.state.productFormData,
            name: val,
          },
        },
        this.validate
      );
    }
  };

  setDescription = (value: string) => {
    this.setState({
      productFormData: {
        ...this.state.productFormData,
        description: value,
      },
    });
  };

  setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (value.trim() === "" || (/^[a-zA-Z0-9 ]*$/g.test(value) && value.trim())) {
      this.setState(
        {
          customCodeError: false,
          productFormData: {
            ...this.state.productFormData,
            code: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          customCodeError: true,
          productFormData: {
            ...this.state.productFormData,
            code: val,
          },
        },
        this.validate
      );
    }
  };

  gradeChangeHandler = (values: any) => {
    this._tempGrade = values;
    if (this.state.productFormData.grade.id === "") {
      this.performGradeChange(this._tempGrade);
    } else {
      this.setState({
        modalWarningGradeChange: true,
      });
    }
  };

  triggerGradeChange = () => {
    this.setState(
      {
        modalWarningGradeChange: false,
      },
      () => {
        this.performGradeChange(this._tempGrade);
      }
    );
  };

  performGradeChange = (values: any) => {
    gradeActions
      .getById(values[0].value)
      .then(() => {
        let properties: IPropertySpecification[] = [];
        this._selectedGrade.measuredProperties.forEach((element: any) => {
          const direction =
            element.direction.name != CONSTANTS.ND
              ? " ( " + element.direction.name + ")"
              : "";
          const pName = element.property.name + direction;
          properties.push(
            new PropertySpecification(
              true,
              false,
              element.instrument.id,
              element.property.id,
              pName,
              element.property.customId,
              element.target === null ? "" : String(element.target),
              element.sigma === null ? "" : String(element.sigma),
              element.gain,
              element.offset,
              element.minValue === null ? "" : String(element.minValue),
              element.maxValue === null ? "" : String(element.maxValue),
              element.alarmLow1 === null ? "" : String(element.alarmLow1),
              element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
              element.alarmLow2 === null ? "" : String(element.alarmLow2),
              element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
              element.rejectLow === null ? "" : String(element.rejectLow),
              element.rejectHigh === null ? "" : String(element.rejectHigh),
              [],
              element.direction,
              element.order
            )
          );
        });

        this._selectedGrade.keyedInProperties.forEach(
          (element: IKeyedInPropertyData) => {
            properties.push(
              new PropertySpecification(
                false,
                false,
                "",
                element.property.id,
                element.property.name,
                element.property.customId,
                element.target === null ? "" : String(element.target),
                element.sigma === null ? "" : String(element.sigma),
                element.gain,
                element.offset,
                element.minValue === null ? "" : String(element.minValue),
                element.maxValue === null ? "" : String(element.maxValue),
                element.alarmLow1 === null ? "" : String(element.alarmLow1),
                element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
                element.alarmLow2 === null ? "" : String(element.alarmLow2),
                element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
                element.rejectLow === null ? "" : String(element.rejectLow),
                element.rejectHigh === null ? "" : String(element.rejectHigh),
                [],
                [],
                element.order
              )
            );
          }
        );

        this._selectedGrade.calculatedProperties.forEach(
          (element: ICalculatedPropertyData) => {
            properties.push(
              new PropertySpecification(
                false,
                true,
                "",
                element.property.id,
                element.property.name,
                element.property.customId,
                element.target === null ? "" : String(element.target),
                element.sigma === null ? "" : String(element.sigma),
                element.gain,
                element.offset,
                element.minValue === null ? "" : String(element.minValue),
                element.maxValue === null ? "" : String(element.maxValue),
                element.alarmLow1 === null ? "" : String(element.alarmLow1),
                element.alarmHigh1 === null ? "" : String(element.alarmHigh1),
                element.alarmLow2 === null ? "" : String(element.alarmLow2),
                element.alarmHigh2 === null ? "" : String(element.alarmHigh2),
                element.rejectLow === null ? "" : String(element.rejectLow),
                element.rejectHigh === null ? "" : String(element.rejectHigh),
                [],
                element.order
              )
            );
          }
        );
        properties = properties?.sort((a: any, b: any) => a.order - b.order);
        this.setState(
          {
            productFormData: {
              ...this.state.productFormData,
              selectedGrade: [
                {
                  label: this._selectedGrade.name,
                  value: this._selectedGrade.id,
                },
              ],
              grade: new GradeBasicData(
                this._selectedGrade.id,
                this._selectedGrade.name,
                this._selectedGrade.description,
                this._selectedGrade.code,
                this._selectedGrade.isEnabled
              ),
              properties,
            },
          },
          this.validate
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onChangeValue = (e: any, rowIndex: number, colIndex: number) => {
    const name = e === "sigmaPercent" ? e : e.target.name;

    const properties = [...this.state.productFormData.properties];
    const item: any = properties[rowIndex];

    if (name.indexOf(".") !== -1) {
      const data = e.target.name.split(".");
      let result: any = item;
      for (let index = 0; index < data.length - 1; index++) {
        result = result[data[index]];
      }
      const targetVal = e.target.value;
      result[data[data.length - 1]] = targetVal;
    } else if (name === "sigmaPercent") {
      item["sigmaPercent"] = !item["sigmaPercent"];
    } else {
      const targetVal = e.target.value;
      item[e.target.name] = targetVal;
    }

    if (item["sigma"] && item["target"]) {
      if (item["sigmaPercent"]) {
        const sigma = parseFloat(item["sigma"]);
        const temp = (parseFloat(item["target"]) * sigma) / 100;
        item["alarmLow1"] = (parseFloat(item["target"]) - temp).toString();
        item["alarmHigh1"] = (parseFloat(item["target"]) + temp).toString();
      } else {
        if (
          item["sigma"].length &&
          item["target"].length &&
          (e === "sigmaPercent" ||
            e.target.name === "sigma" ||
            e.target.name === "target")
        ) {
          item["alarmLow1"] = (
            parseFloat(item["target"]) - parseFloat(item["sigma"])
          ).toString();
          item["alarmHigh1"] = (
            parseFloat(item["target"]) + parseFloat(item["sigma"])
          ).toString();
        }
      }
    }

    properties[rowIndex] = item;
    this.setState(
      {
        productFormData: { ...this.state.productFormData, properties },
      },
      () => {
      }
    );
  };

  private onBlurValue = (e: any, rowIndex: number, colIndex: number) => {
    const properties = [...this.state.productFormData.properties];
    // reverse case for min and max value
    if (
      properties[rowIndex].minValue &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].minValue) !== 0 &&
      Number(properties[rowIndex].maxValue) !== 0 &&
      Number(properties[rowIndex].maxValue) <
        Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.MIN_MAX_ERROR);
    }

    // rejectHigh
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].rejectLow) !== 0 &&
      Number(properties[rowIndex].rejectLow) <=
        Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_LOW_MIN_ERROR);
    }
    if (
      properties[rowIndex].rejectHigh &&
      properties[rowIndex].maxValue &&
      Number(properties[rowIndex].rejectHigh) !== 0 &&
      Number(properties[rowIndex].rejectHigh) >=
        Number(properties[rowIndex].maxValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_HIGH_MAX_ERROR);
    }

    // alarm low 2
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) <=
        Number(properties[rowIndex].rejectLow)
    ) {
      triggerNotifications.error(CONSTANTS.LOW_REJECT_LOW_ERROR);
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].rejectHigh &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) >=
        Number(properties[rowIndex].rejectHigh)
    ) {
      triggerNotifications.error(CONSTANTS.HIGH_REJECT_HIGH_ERROR);
    }

    // low1
    if (
      properties[rowIndex].alarmLow1 &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow1) !== 0 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) >=
        Number(properties[rowIndex].alarmLow1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.LOW1_LOW2_ERROR));
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].alarmHigh1 &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh1) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) <=
        Number(properties[rowIndex].alarmHigh1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.HIGH1_HIGH2_ERROR));
    }
  };

  onCancelClick = () => {
    History.push(CONSTANTS.PRODUCT_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll-height">
            <div className="layout-container">
              <SubmitHeader
                name={MODULE_PRODUCT}
                link={CONSTANTS.PATH_PRODUCT}
                isEdit={this.state.productFormData.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-4">
                <div className="col-6 no-padding float-left">
                  <div className="box">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.MENU_PRODUCT) +
                          " " +
                          t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      </p>
                    </div>
                    <hr className="hr-line" />
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          className={
                            this.state.customCodeError
                              ? "error-code mt-2 w-25"
                              : "mt-2 w-25"
                          }
                          dataType="text"
                          label={t(CONSTANTS.PRODUCT_CODE)}
                          placeholder={t(CONSTANTS.PRODUCT_CODE)}
                          // required={true}
                          value={String(this.state.productFormData.code)}
                          onValueChange={this.setCode}
                          maxLength={10}
                          showValidationBarWhenInvalid={
                            this.state.customCodeError ? true : false
                          }
                          description={
                            this.state.customCodeError
                              ? this.state.productFormData.code.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={this.state.productFormData.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={
                            this.state.nameError ? true : false
                          }
                          description={
                            this.state.nameError
                              ? this.state.productFormData.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.productFormData.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {200 - this.state.productFormData.description.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>

                <div className="col-md-6 no-padding float-left">
                  <div className="box box-height ml-3">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />
                    <div className="row mt-3">
                      <div className="col-sm-6 col-md-6">
                        <Dropdown
                          label={t(CONSTANTS.MENU_GRADE)}
                          allowAdd={false}
                          required={true}
                          clearable={false}
                          placeholder={t(CONSTANTS.NO_GRADE_SELECTED)}
                          searchable={true}
                          value={this.state.productFormData.selectedGrade}
                          onChange={this.gradeChangeHandler}
                        >
                          {this.state.gradeDropdownList.map((o: any, index) => (
                            <DropdownOption
                              key={index}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              {this._selectedGrade ||
              (this.state.productFormData.isEditMode &&
                this.state.productFormData.selectedGrade) ? (
                <div className="create_property box-below-form mb-4">
                  <div className="box-circle">
                    <p className="box-circle-text"> 3 </p>
                  </div>
                  <div className="ml-4">
                    <div className="sidebar-main-title font-weight-bold ml-2">
                      {t(CONSTANTS.LABEL_PROPERTIES)}
                    </div>
                  </div>
                  <div className="w-100">
                    <AbbTableComponent
                    authKey={CONSTANTS.AUTHKEY_PRODUCT}
                      columns={[
                        {
                          dataField: "propertyName",
                          text: t(CONSTANTS.MODULE_PROPERTY),
                          editable: false,
                          isFixed: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "15%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "propertyCustomId",
                          text: t(CONSTANTS.LABLE_ID),
                          editable: false,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "target",
                          text: t(CONSTANTS.TARGET),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "4%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "sigma",
                          text: t(CONSTANTS.SIGMA),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "sigmapercent",
                          text: t(CONSTANTS.SIGMA_PERCENT),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "middle" };
                          },
                        },
                        {
                          dataField: "minValue",
                          text: t(
                            CONSTANTS.LABLE_MIN + " " + CONSTANTS.LABEL_VALUE
                          ),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "maxValue",
                          text: t(
                            CONSTANTS.LABLE_MAX + " " + CONSTANTS.LABEL_VALUE
                          ),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "alarmLow1",
                          text: t(CONSTANTS.ALARMLOWONE),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "alarmHigh1",
                          text: t(CONSTANTS.ALARMHIGHONE),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "alarmLow2",
                          text: t(CONSTANTS.ALARMLOWTWO),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "alarmHigh2",
                          text: t(CONSTANTS.ALARMHIGHTWO),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "rejectLow",
                          text: t(CONSTANTS.REJECTLOW),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "rejectHigh",
                          text: t(CONSTANTS.REJECTHIGH),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "gain",
                          text: t(CONSTANTS.GAIN),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                        {
                          dataField: "offset",
                          text: t(CONSTANTS.OFFSET),
                          isEditable: true,
                          headerStyle: (colum, colIndex) => {
                            return { width: "10%", textAlign: "left" };
                          },
                        },
                      ]}
                      list={this.state.productFormData.properties}
                      select={false}
                      isFixedColumn={true}
                      isEditable={true}
                      delete={false}
                      cellEdit={this.onChangeValue}
                      cellBlurEdit={this.onBlurValue}
                      form={true}
                      moduleName={t(CONSTANTS.MODULE_PRODUCT)}
                      name={
                        t(CONSTANTS.MODULE_PRODUCT) +
                        " " +
                        CONSTANTS.MODULE_PROPERTY
                      }
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <Dialog
              isOpen={this.state.modalWarningGradeChange}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ modalWarningGradeChange: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.GRADE_SELECTION_CHANGE)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.triggerGradeChange,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.PROPERTY_LOST_MESSAGE)}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b>{" "}
                {t(CONSTANTS.PRODUCT_MAPPING_LOST_MESSAGE)}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
